import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import api, { NOTICE_KEY } from '../api/client';
import AuthShell, { Field } from '../components/layout/AuthShell';
import AlertMessage from '../components/ui/AlertMessage';
import PasswordInput from '../components/ui/PasswordInput';

/**
 * A bot oldalának belépése (bot.mortisengine.com) — kilépve CSAK ez látszik.
 *
 * A tulajdonos (2026-10-06): „ott szigorúan csak bejelentkezés oldal lenne ha nincs belépve”, és a lapon NINCS link
 * (regisztráció, elfelejtett jelszó). 2026-10-08 óta az app SAJÁT belépésével (ugyanaz a loaderben; a ticketben kapott
 * kóddal regisztrálják — RegisterPage.jsx); belépni élő előfizetéssel lehet (fagyasztva is), az elutasítás oka
 * szövegként jelenik meg (a MortisCodex-adatokra a szokásos „Invalid username or password.” — a kapcsolatot nem
 * áruljuk el).
 * Ha belépve járt le az előfizetés, a kiléptetés oka (api/client.js) itt jelenik meg.
 */
export default function LoginPage() {
  const { login } = useAuth();
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState(null);
  const [notice, setNotice] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    try {
      const n = sessionStorage.getItem(NOTICE_KEY);
      if (n) { setNotice(n); sessionStorage.removeItem(NOTICE_KEY); }
    } catch { /* tiltott tároló */ }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setNotice(null);
    setLoading(true);
    try {
      const res = await api.post('/auth/login', form);
      // A belépve látható útvonalakra a váz (App.jsx) maga vált át.
      login(res.data.user, res.data.accessToken, res.data.refreshToken);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong while signing in.');
      setLoading(false);
    }
  };

  return (
    <AuthShell
      bar="Sign in"
      title="Sign in"
      subtitle="Use your app login — the same one as in the loader."
    >
      <AlertMessage msg={notice ? { type: 'warn', text: notice } : null} className="" />
      <AlertMessage msg={error ? { type: 'error', text: error } : null} className="" />

      <form onSubmit={handleSubmit} className="flex flex-col gap-[18px]">
        <Field label="Username" htmlFor="login-user">
          <input
            id="login-user"
            type="text"
            className="input"
            placeholder="darkuser99"
            value={form.username}
            onChange={e => setForm(p => ({ ...p, username: e.target.value }))}
            autoComplete="username"
            required
          />
        </Field>

        <Field label="Password" htmlFor="login-pass">
          <PasswordInput
            id="login-pass"
            value={form.password}
            onChange={v => setForm(p => ({ ...p, password: v }))}
            autoComplete="current-password"
            required
          />
        </Field>

        <button type="submit" className="btn-primary w-full" disabled={loading}>
          {loading ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </AuthShell>
  );
}
